import { Component, OnInit, Input } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
    selector: 'app-admin-charts',
    templateUrl: './admin-charts.component.html',
    styleUrls: ['./admin-charts.component.scss']
})
export class AdminChartsComponent implements OnInit {
    @Input() chart: any;
    @Input() id: any;
    @Input() dbData: any;

    labelArray: string[] = [];
    valuesArray: number[] = [];
    

    constructor() { }

    ngOnInit() {
    }

    ngAfterViewInit() {
        if (this.dbData && this.chart) {
            for (let i = 0; i < this.dbData.length; i++) {
                if (this.dbData[i].id == this.chart) {
                    let labelSplit = this.dbData[i].label.split(', ');
                    let valueSplit = [];
                    valueSplit = this.dbData[i].value.split(',');
                    this.labelArray = [];
                    this.valuesArray = [];
                    for (let x = 0; x < valueSplit.length; x++) {
                        if (valueSplit[x].length > 0) {
                            let dataSplit = [];
                            dataSplit = valueSplit[x].split(': ');
                            this.labelArray.push(dataSplit[0]);
                            this.valuesArray.push(dataSplit[1]);
                        }
                    }
                    this.addchart((i + 1).toString(), this.labelArray, this.valuesArray);
                }
            }
        }
    }

    addchart(chartid: string, labelArray: string[], dataArray: number[]) {
        var canvas = <HTMLCanvasElement>document.getElementById(chartid);
        var mychart = new Chart(canvas, {
            type: 'line',
            data: {
                labels: labelArray,
                datasets: [{
                    data: dataArray,
                    borderColor: 'rgba(52,152,219,1)',
                    borderWidth: 1,
                    fill: false
                }]
            },
            options: {
                responsive: true,
                animation: {
                    animateScale: true,
                    animateRotate: true
                },
                plugins: {
                    tooltip: {
                        intersect: false
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                legend: {
                    display: false
                },
                elements: {
                    point: {
                        hitRadius: 5
                    }
                }
            }
        });
    }

}